import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Hero } from "./components/strake/Hero";
import { Favourites } from "./components/strake/Favourites";
import { Menu } from "./components/strake/Menu";
import { Patio } from "./components/strake/Patio";
import { FeaturedIn } from "./components/strake/FeaturedIn";
import { Reviews } from "./components/strake/Reviews";
import { Gallery } from "./components/strake/Gallery";
import { Location } from "./components/strake/Location";
import { ContentProvider } from "./ContentContext";
import { AdminLogin } from "./admin/AdminLogin";
import { AdminDashboard } from "./admin/AdminDashboard";

const Home = () => (
    <main
        data-testid="strake-home"
        className="w-full max-w-md md:max-w-xl mx-auto bg-[#EFE7DB] min-h-screen shadow-[0_0_60px_rgba(0,0,0,0.15)] relative overflow-hidden font-body"
    >
        <Hero />
        <Favourites />
        <Menu />
        <Patio />
        <FeaturedIn />
        <Reviews />
        <Gallery />
        <Location />
    </main>
);

function App() {
    return (
        <div className="App bg-[#0a0a0a] min-h-screen">
            <BrowserRouter>
                <ContentProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/*" element={<AdminDashboard />} />
                    </Routes>
                </ContentProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
